// extracted by mini-css-extract-plugin
export var card = "styles-module--card--98751";
export var cards = "styles-module--cards--1f6c2";
export var description = "styles-module--description--2d720";
export var title = "styles-module--title--960bf";